import { usePageContext } from "@src/components/general/WrapPageElement/PageContext";
import { useAppSelector } from "@src/store/hooks";

export const useCurrentPageContextIntl = () => {
  const { pageContext: currentPageContext } = usePageContext();
  return currentPageContext;
};
export const useLayoutHistory = () =>
  useAppSelector(({ page }) => page.layoutHistory);
